import type {
  AdaptiveScanningStateDto,
  AdaptiveScanningTargetBlockReason,
} from '@terra/shared-contracts-applications';

const TARGET_REASONS: AdaptiveScanningTargetBlockReason[] = [
  'waf',
  'rate_limit',
  'anti_bot_system',
  'server_unreachable',
];

export const selectAdaptiveResumeReasons = (
  state: Pick<AdaptiveScanningStateDto, 'pausedReason' | 'blockedReasonCounts'>,
): AdaptiveScanningTargetBlockReason[] => {
  const availableReasons = TARGET_REASONS.filter((reason) => {
    const count =
      state.blockedReasonCounts.find((entry) => entry.reason === reason)
        ?.count ?? 0;

    return count > 0;
  });
  const pausedTargetReason = availableReasons.find(
    (reason) => reason === state.pausedReason,
  );

  if (pausedTargetReason) {
    return [pausedTargetReason];
  }

  return availableReasons;
};
